import React, {useState, useEffect, useContext, useRef} from 'react';
import {withRouter} from 'react-router-dom';
import userDefaultImage from '../../assets/svg/user-default-icon.svg';
import VIDABOO_CONSTANTS from '../../config/consts';
import './mentorsDirectoryComponent.css';
import {AppContext} from '../../AppModule/Context';
import magazineChatGreen from '../../assets/svg/magazine-chat-green.svg';
import magazineChatGray from '../../assets/svg/magazine-chat-gray.svg';
import magazineChatOrange from '../../assets/svg/magazine-chat-orange.svg';
import MultiStateButton from '../../components/common/genericComponents/redesign/multiStateButton/multiStateButton';
import {withWidgetContext} from '../../components/widgetComponent/widgetContextProvider';
import cnameInstanceService from '../../services/restServices/cnameInstanceService';
import utilsService from '../../services/utilsService';

const NUM_OF_BATCH_REQUESTS = 12;

const MentorsDirectoryComponent = ({
  filteredSortedMentorsCtrlDtoValues = [],
  widgetContext = {},
}) => {
  const context = useContext(AppContext);
  const [visibleWidgetMentorCtrlDtosVal, setVisibleWidgetMentorCtrlDtosVal] =
    useState([]);
  const [spinnerId, setSpinnerId] = useState(null);
  const observerRef = useRef(null);
  const lastItemRef = useRef(null);
  const currentBatch = useRef(0);

  useEffect(() => {
    initObserver();
    buildWidgets();
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  useEffect(() => {
    buildWidgetsAfterFilteredMentorsChanged();
  }, [filteredSortedMentorsCtrlDtoValues]);

  useEffect(() => {
    //stop observing previous item
    observerRef.current?.disconnect();
    //start observing new item
    if (lastItemRef.current) {
      observerRef.current.observe(lastItemRef.current);
    }
  }, [lastItemRef.current, visibleWidgetMentorCtrlDtosVal]);

  const initObserver = () => {
    const options = {
      threshold: 0.8,
    };
    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreWidgets();
        }
      });
    };
    observerRef.current = new IntersectionObserver(handleIntersect, options);
  };

  const buildWidgets = () => {
    const startIndex = currentBatch.current * NUM_OF_BATCH_REQUESTS;
    const endIndex = startIndex + NUM_OF_BATCH_REQUESTS;

    if (startIndex > filteredSortedMentorsCtrlDtoValues.length - 1) return;
    const visibleWidgetMentorCtrlDtosVal = [
      ...filteredSortedMentorsCtrlDtoValues,
    ].slice(startIndex, endIndex);

    currentBatch.current = currentBatch.current + 1;
    setVisibleWidgetMentorCtrlDtosVal(visibleWidgetMentorCtrlDtosVal);
  };

  const buildWidgetsAfterFilteredMentorsChanged = () => {
    const startIndex = currentBatch.current * NUM_OF_BATCH_REQUESTS;
    const endIndex = startIndex + NUM_OF_BATCH_REQUESTS;

    const visibleWidgetMentorCtrlDtosVal = [
      ...filteredSortedMentorsCtrlDtoValues,
    ].slice(0, endIndex);

    setVisibleWidgetMentorCtrlDtosVal(visibleWidgetMentorCtrlDtosVal);
  };

  const loadMoreWidgets = () => {
    const startIndex = currentBatch.current * NUM_OF_BATCH_REQUESTS;
    const endIndex = startIndex + NUM_OF_BATCH_REQUESTS;
    if (startIndex > filteredSortedMentorsCtrlDtoValues.length - 1) return;

    const visibleWidgetMentorCtrlDtosVal = [
      ...filteredSortedMentorsCtrlDtoValues,
    ].slice(0, endIndex);

    // Set the fetched widgets to the state
    setVisibleWidgetMentorCtrlDtosVal(visibleWidgetMentorCtrlDtosVal);

    // Increment batch number
    currentBatch.current = currentBatch.current + 1;
    if (startIndex !== 0) scrollForNewElements(); // not first batch
  };

  const scrollForNewElements = () => {
    const element = document.querySelector('.et-mdc-items-wrap');
    if (element) {
      element.scrollTo({
        top: element.scrollTop + 200,
        behavior: 'smooth',
      });
    }
  };
  const getPhotoManipulatedUrl = (photoDto) => {
    const manipulationString = 'q_auto:eco,c_fit,h_350,w_350';
    const manipulatedPhotoUrl = utilsService.getPhotoManipulatedUrl(
      photoDto,
      manipulationString,
    );
    return manipulatedPhotoUrl;
  };

  const openPersonalPage = async (mentorDto) => {
    setSpinnerId(mentorDto.mentorId);
    const domainUrl = await cnameInstanceService.getDomainUrlByWidgetId(
      widgetContext.widgetDto.widgetId,
    );
    setSpinnerId(null);
    const link = domainUrl + '/expert/' + mentorDto.profileName;
    window.open(link, '_blank', 'noopener noreferrer');
  };
  return (
    <>
      {visibleWidgetMentorCtrlDtosVal.length > 0 && (
        <div className="et-mentors-directory-component-container">
          {/* <div className="et-mdc-title-wrap" dir="auto">
          <div className="et-mdc-title-wrap-title" dir="auto">
            אנחנו כאן בשבילך{' '}
          </div>
          <div className="et-mdc-title-wrap-subtitle" dir="auto">
            שיחה עם אוזן קשבת במרחק לחיצה{' '}
          </div>
        </div> */}
          <div className="et-mdc-items-wrap">
            {visibleWidgetMentorCtrlDtosVal.map(
              ({extendedMentorDto}, index) => {
                const isLastItem =
                  index === visibleWidgetMentorCtrlDtosVal.length - 1;

                // console.log(`Rendering item ${index}. Is last? ${isLastItem}`);

                return (
                  <div
                    key={extendedMentorDto.mentorDto.mentorId + index} //todo: remove index
                    className="et-mdc-item-wrap"
                    ref={isLastItem ? lastItemRef : null}
                    dir="auto">
                    {/* {isLastItem ? 'LAST ITEM' : 'NOT LAST'} */}
                    <div className="et-mdc-item-img-wrap">
                      <img
                        src={
                          extendedMentorDto.photoDto
                            ? getPhotoManipulatedUrl(extendedMentorDto.photoDto)
                            : userDefaultImage
                        }
                        alt=""
                      />
                    </div>
                    <div className="et-mdc-item-bottom-wrap">
                      <div className="et-mdc-item-title-wrap" dir="auto">
                        <div
                          className="et-mdc-item-title-wrap-title"
                          dir="auto">
                          {extendedMentorDto.mentorDto.displayName}
                        </div>

                        <div
                          className="et-mdc-item-title-wrap-description"
                          dir="auto">
                          {extendedMentorDto.sessionTemplateDto?.sessionTitle}
                        </div>
                      </div>
                      <div className="et-mdc-item-bottom-button-wrap">
                        <MultiStateButton
                          isDisabled={spinnerId}
                          isPrimaryBtn
                          showSpinner={
                            extendedMentorDto.mentorDto.mentorId === spinnerId
                          }
                          btnTxt="  יצירת קשר"
                          onClick={() =>
                            openPersonalPage(extendedMentorDto.mentorDto)
                          }
                        />
                        <div
                          className={
                            'et-mdc-item-bottom-btn-icon et-magazine-content-chat-icon ' +
                            (context.peersStatus[
                              extendedMentorDto.mentorDto.mentorOwnerId
                            ] ===
                            VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
                              ? 'et-magazine-chat-green-bg'
                              : context.peersStatus[
                                    extendedMentorDto.mentorDto.mentorOwnerId
                                  ] ===
                                  VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
                                ? 'et-magazine-chat-orange-bg'
                                : 'et-magazine-chat-grey-bg')
                          }>
                          <img
                            src={
                              context.peersStatus[
                                extendedMentorDto.mentorDto.mentorOwnerId
                              ] ===
                              VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
                                ? magazineChatGreen
                                : context.peersStatus[
                                      extendedMentorDto.mentorDto.mentorOwnerId
                                    ] ===
                                    VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
                                  ? magazineChatOrange
                                  : magazineChatGray
                            }
                            alt="chat"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              },
            )}
          </div>
          {/* <div
            className="et-mdc-load-more-wrap"
            onClick={() => {
              loadMoreWidgets(widgetMentorCtrlDtosVal);
            }}>
            <div className="et-mdc-load-more-bottom-btn">עוד מטפלים</div>
          </div> */}
        </div>
      )}
    </>
  );
};
export default withRouter(withWidgetContext(MentorsDirectoryComponent));
